import {useCallback} from 'react';
import {useTrackingClient} from '../../tracking/context/TrackingClientContext';

export default function useTrackDropSubscription() {
  const gtmTrackingClient = useTrackingClient();

  const trackDropsSubscription = useCallback(
    (label: 'all' | 'upcoming') => {
      if (gtmTrackingClient) {
        gtmTrackingClient.trackHotDrops({
          label,
        });
      }
    },
    [gtmTrackingClient],
  );
  return trackDropsSubscription;
}
